import { CalmMetadata } from './metadata.js';
import { CalmNode } from './node.js';
import { CalmRelationship } from './relationship.js';
import { CalmControls } from './control.js';
import { CalmFlow } from './flow.js';
export class CalmCore {
    constructor(originalJson, nodes = [], relationships = [], controls, flows, metadata, adrs) {
        this.originalJson = originalJson;
        this.nodes = nodes;
        this.relationships = relationships;
        this.controls = controls;
        this.flows = flows;
        this.metadata = metadata;
        this.adrs = adrs;
    }
    toCanonicalSchema() {
        return {
            nodes: this.nodes.map(node => node.toCanonicalSchema()),
            relationships: this.relationships.map(relationship => relationship.toCanonicalSchema()),
            controls: this.controls ? this.controls.toCanonicalSchema() : undefined,
            flows: this.flows ? this.flows.map(flow => flow.toCanonicalSchema()) : undefined,
            metadata: this.metadata ? this.metadata.toCanonicalSchema() : undefined,
            adrs: this.adrs ? this.adrs : undefined
        };
    }
    static fromSchema(schema) {
        return new CalmCore(schema, (schema.nodes ?? []).map(CalmNode.fromSchema), (schema.relationships ?? []).map(CalmRelationship.fromSchema), schema.controls ? CalmControls.fromSchema(schema.controls) : undefined, schema.flows ? schema.flows.map(CalmFlow.fromSchema) : undefined, schema.metadata ? CalmMetadata.fromSchema(schema.metadata) : undefined, schema.adrs);
    }
    toSchema() {
        return this.originalJson;
    }
}
//# sourceMappingURL=core.js.map